import React from 'react';
import {
  formatMissingTokenContractBanner,
  getMissingErc20TokenContracts,
} from '../../../../services/wallet/linkedWallet.utils';
import { getWalletProviderIcon } from '../SelectWalletModal/walletProviderIcons';

const SelectedWalletChip = ({
  wallet,
  selectedPair,
  paymentAssetLabel = '',
  onChangeWallet,
  disabled = false,
}) => {
  if (!wallet) return null;

  const missingTokens = getMissingErc20TokenContracts(wallet, selectedPair);
  const tokenConfigBanner =
    missingTokens.length > 0 ? formatMissingTokenContractBanner(missingTokens) : null;
  const providerIcon = getWalletProviderIcon(wallet);

  const payLabel =
    paymentAssetLabel ||
    (wallet.coinName ? String(wallet.coinName).toUpperCase() : '');

  const walletDisplayLabel = `${wallet.walletTypeLabel} · ${wallet.shortAddress}`;

  return (
    <div className="buySelltab__walletChipWrap">
      <div className="buySelltab__walletChip">
        {providerIcon ? (
          <div className="buySelltab__walletChipIconWrap" aria-hidden="true">
            <img
              src={providerIcon}
              alt=""
              className="buySelltab__walletChipIcon"
            />
          </div>
        ) : null}
        <div className="buySelltab__walletChipMain">
          <span
            className="buySelltab__walletChipName"
            title={wallet.address || walletDisplayLabel}
          >
            {walletDisplayLabel}
          </span>
          {payLabel ? (
            <span className="buySelltab__walletChipPay">Pays with {payLabel}</span>
          ) : null}
        </div>
        <button
          type="button"
          className="buySelltab__walletChangeBtn"
          onClick={onChangeWallet}
          disabled={disabled}
        >
          Change
        </button>
      </div>
      {tokenConfigBanner ? (
        <p className="buySelltab__walletChipWarning" role="status">
          {tokenConfigBanner}
        </p>
      ) : null}
    </div>
  );
};

export default SelectedWalletChip;
